module.exports = __webpack_public_path__ + "img/donante-tv-azteca.3d5df309.png";